import type { SVGProps } from "react";

/**
 * feature, shine
 * @category Interface General
 */
export default function IconFeature(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M12 1.75V8.25M12 15.75V22.25M8.25 12H1.75M15.75 12H22.25M8 8L6 6M16 8L18 6M16 16L18 18M8 16L6 18'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
